/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Compact from './Compact/index'
import No from './No/index'
import React from 'react'
import Timeline from './Timeline/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentCardSettingsDataDefaultViewValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card_settings',
path: 'data.default_view',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: treatmentCardSettingsDataDefaultViewValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Timeline'}>
<Timeline
  viewPath={`${viewPath}/Timeline`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Compact'}>
<Compact
  viewPath={`${viewPath}/Compact`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}